// doctor-frontend/src/services/profileApi.js
// Tenant-aware profile API using the shared HTTP client.

import http, { getJSON, putJSON } from './http';

/**
 * Notes:
 * - http.* already prefixes /t/<slug> when needed and adds:
 *   Authorization: Bearer <user token>, X-Tenant-Slug, cache-bust, etc.
 * - Any 401/403 will dispatch "auth:unauthorized" on window.
 */

function wrap(fn) {
  return async (...args) => {
    try {
      return await fn(...args);
    } catch (e) {
      const status = e?.response?.status;
      const msg =
        e?.response?.data?.message ||
        e?.message ||
        (status === 401 ? 'Invalid or expired token.' : 'Request failed');
      const err = new Error(msg);
      if (e?.response) err.response = e.response;
      throw err;
    }
  };
}

export const profileApi = {
  getMe: wrap(() => getJSON('/api/profiles/me')),
  saveMe: wrap((payload) => putJSON('/api/profiles/me', payload)),

  list: wrap((params = {}) => {
    const q = new URLSearchParams();
    if (params.role) q.set('role', params.role);
    if (params.centre) q.set('centre', params.centre);
    if (params.q) q.set('q', params.q);
    if (params.page) q.set('page', params.page);
    if (params.limit) q.set('limit', params.limit);
    const qs = q.toString();
    return getJSON(`/api/profiles${qs ? `?${qs}` : ''}`);
  }),

  getByUserId: wrap((userId) => getJSON(`/api/profiles/${userId}`)),
  updateByUserId: wrap((userId, payload) => putJSON(`/api/profiles/${userId}`, payload)),
};

// Admin-only: backfill missing profiles for existing users (tenant-scoped)
export async function backfillProfilesAdmin() {
  const res = await http.post('/api/profiles/admin/backfill', {});
  return res?.data || res;
}

export default profileApi;
